import React, { useCallback, useState } from 'react';
import * as Yup from 'yup';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { DynamicForm, SubmitBtn, Copyright, Info } from '../../components';
import { useRoutes, useApi } from '../../hooks';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(5),
  },
  resetPassword: {
    marginTop: theme.spacing(3),
  },
  action: {
    flex: 1,
  },
  secondBtn: {
    width: `100%`,
    marginTop: theme.spacing(3),
  },
  info: {
    marginTop: theme.spacing(7),
    marginBottom: theme.spacing(5),
  },
}));

export const ForgetPassword: React.FC = () => {
  const classes = useStyles();
  const [error, setError] = useState('');
  const { paths, navigate } = useRoutes();
  const { resetPassword } = useApi();
  const navigateToLogin = navigate(paths.login.path);

  const handleOnSubmit = useCallback(
    async ({ username }) => {
      try {
        const response = await resetPassword(username);
        if (!response) {
          throw new Error();
        }
        navigateToLogin();
      } catch (error) {
        setError('auth/invalid-username');
      }
    },
    [navigateToLogin, resetPassword]
  );

  return (
    <div>
      <CssBaseline />
      <Container maxWidth="sm" className={classes.container}>
        <Typography variant="h4" component="h4" align="center">
          Mot de passe oublié
        </Typography>
        <DynamicForm
          fields={{
            username: {
              label: 'Identifiant (numéro de CP)',
              initialValue: '',
              type: 'text',
            },
          }}
          validationSchema={Yup.object({
            username: Yup.string().required('Ce champ est requis'),
          })}
          onSubmit={handleOnSubmit}
          error={error}
        >
          {(form: any) => (
            <SubmitBtn
              color="primary"
              title="Valider"
              variant="contained"
              className={classes.action}
              disabled={!form.isValid || form.isSubmitting}
              isSubmitting={form.isSubmitting}
            />
          )}
        </DynamicForm>
        <Button color="primary" className={classes.secondBtn} onClick={navigateToLogin}>
          Se connecter
        </Button>
        <div className={classes.info}>
          <Info
            title="Mot de passe oublié ? Pas d'inquiétude !"
            subtitle="Tu recevras ton nouveau mot de passe sur ton adresse email ! Vérifie bien !"
          />
        </div>
        <Copyright />
      </Container>
    </div>
  );
};

export default ForgetPassword;
